import React from 'react'
import cleint from '../images/ashlok_way/cleint_logo.png';
import cleint2x from '../images/ashlok_way/cleint_logo@2x.png';

import reliance from '../images/ashlok_way/clients/reliance.png';
import reliance2x from '../images/ashlok_way/clients/reliance@2x.png';

import aarti from '../images/ashlok_way/clients/aarti.png';
import aarti2x from '../images/ashlok_way/clients/aarti@2x.png';
import barc from '../images/ashlok_way/clients/barc.png';
import barc2x from '../images/ashlok_way/clients/barc@2x.png';
import fine_organics from '../images/ashlok_way/clients/fine-organics.png';
import fine_organics2x from '../images/ashlok_way/clients/fine-organics@2x.png';
import gits from '../images/ashlok_way/clients/gits.png';
import gits2x from '../images/ashlok_way/clients/gits@2x.png';
import henkel from '../images/ashlok_way/clients/henkel.png';
import henkel2x from '../images/ashlok_way/clients/henkel@2x.png';
import indian_oil from '../images/ashlok_way/clients/indian-oil.png';
import indian_oil2x from '../images/ashlok_way/clients/indian-oil@2x.png';
import indospace from '../images/ashlok_way/clients/indospace.png';
import indospace2x from '../images/ashlok_way/clients/indospace@2x.png';
import jsw from '../images/ashlok_way/clients/jsw.png';
import jsw2x from '../images/ashlok_way/clients/jsw@2x.png';
import lodha from '../images/ashlok_way/clients/lodha.png';
import lodha2x from '../images/ashlok_way/clients/lodha@2x.png';
import lubrizol from '../images/ashlok_way/clients/lubrizol.png';
import lubrizol2x from '../images/ashlok_way/clients/lubrizol@2x.png';
import mahanagar_gas from '../images/ashlok_way/clients/mahanagar-gas.png';
import mahanagar_gas2x from '../images/ashlok_way/clients/mahanagar-gas@2x.png';
import mahindra from '../images/ashlok_way/clients/mahindra.png';
import mahindra2x from '../images/ashlok_way/clients/mahindra@2x.png';
import mastek from '../images/ashlok_way/clients/mastek.png';
import mastek2x  from '../images/ashlok_way/clients/mastek@2x.png';
import military from '../images/ashlok_way/clients/military.png';
import military2x from '../images/ashlok_way/clients/military@2x.png';
import piramal from '../images/ashlok_way/clients/piramal.png';
import piramal2x from '../images/ashlok_way/clients/piramal@2x.png';
import precision from '../images/ashlok_way/clients/precision.png';
import precision2x from '../images/ashlok_way/clients/precision@2x.png';
import smart_point from '../images/ashlok_way/clients/smart-point.png';
import smart_point2x from '../images/ashlok_way/clients/smart-point@2x.png';
import tata_housing from '../images/ashlok_way/clients/tata-housing.png';
import tata_housing2x from '../images/ashlok_way/clients/tata-housing@2x.png';
import tata_motors from '../images/ashlok_way/clients/tata-motors.png';
import tata_motors2x from '../images/ashlok_way/clients/tata-motors@2x.png';
import unity from '../images/ashlok_way/clients/unity.png';
import unity2x from '../images/ashlok_way/clients/unity@2x.png';
import vikram_solar from '../images/ashlok_way/clients/vikram-solar.png';
import vikram_solar2x from '../images/ashlok_way/clients/vikram-solar@2x.png';
import dmart from '../images/ashlok_way/clients/dmart.png';
import dmart2x from '../images/ashlok_way/clients/dmart@2x.png';


// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';
// import './hcarsol.css';
// import InfiniteScrollCarousel from './InfiniteScrollCarousel';
import Infinitescrollnew from './Infinitescrollnew';
// import Infinitescroll from './Infinitescroll';
// import Scrollhorizontal from './Scrollhorizontal';



const clientImageUrl = [
  //First image url
   {
    url:reliance,
    url2x:reliance2x,
    alt:'Reliance Industries Limited Logo - Partner with Ashlok Safe Earthing Electrode Limited'
  },
   {
    url:aarti,
    url2x:aarti2x,
    alt:'Aarti Industries Limited Logo - Ashlok Safe Earthing Electrodes providing grounding solutions for Aarti Industries'
  },
   {
    url:barc,
    url2x:barc2x,
    alt:'BARC Logo - Ashlok Safe Earthing Electrodes in use at BARC (Bhabha Atomic Research Centre) for critical earthing solutions'
  },
   {
    url:fine_organics,
    url2x:fine_organics2x,
    alt:'Fine Organics Logo – "Fine Organics Logo | Ashlok Safe Earthing Electrodes Manufacturer & Supplier'
  },
   {
    url:gits,
    url2x:gits2x,
    alt:'Gits Logo | Ashlok Safe Earthing Electrodes Manufacturer & Supplier'
  },
   {
    url:henkel,
    url2x:henkel2x,
    alt:'Henkel Logo – "Henkel Logo | Partnering with Ashlok Safe Earthing Electrodes Manufacturer & Supplier'
  },
   {
    url:indian_oil,
    url2x:indian_oil2x,
     alt:'Indian Oil Logo – "Indian Oil Logo | Trusted Client of Ashlok Safe Earthing Electrodes Manufacturer & Supplier'
  },
  {
    url:indospace,
    url2x:indospace2x,
     alt:'ndospace Logo – "Indospace GLP Joint Venture Logo | Ashlok Safe Earthing Electrodes Manufacturer & Supplier'
  },
  {
    url:jsw,
    url2x:jsw2x,
    alt:'JSW Logo - Ashlok Safe Earthing Electrode Limited'
  },
  {
    url:lodha,
    url2x:lodha2x,
    alt:'Lodha Group Logo - Ashlok Safe Earthing Electrode Limited'
  },
  {
    url:lubrizol,
    url2x:lubrizol2x,
     alt:'Lubrizol Logo - Ashlok Safe Earthing Electrode Limited'
  },
  {
    url:mahanagar_gas,
    url2x:mahanagar_gas2x,
    alt:'Mahanagar Gas Logo - Ashlok Safe Earthing Electrodes used in Mahanagar Gas infrastructure for safe grounding solutions'
  },
  {
    url:mahindra,
    url2x:mahindra2x,
   alt:'Mahindra Logo - Ashlok Safe Earthing Electrode Limited'
  },
  {
    url:mastek,
    url2x:mastek2x,
     alt:'Mastek Logo - Ashlok Safe Earthing Electrode Limited'
  },
  {
    url:military,
    url2x:military2x,
     alt:'Ministry of Defence Logo - Ashlok Safe Earthing Electrode Limited'
  },
  {
    url:piramal,
    url2x:piramal2x,
     alt:'Piramal Pharma Limited Logo - Ashlok Safe Earthing Electrode Limited'
  },
  {
    url:precision,
    url2x:precision2x,
     alt:'Precision Pipes and Fittings Logo - Collaboration with Ashlok Safe EarthingElectrode Limited'
  },
  {
    url:smart_point,
    url2x:smart_point2x,
     alt:'Smart Point Logo - Partner with Ashlok Safe Earthing Electrode Limited'
  },
  {
    url:tata_housing,
    url2x:tata_housing2x,
     alt:'Tata Housing Logo - Tata Housing partnership with Ashlok Safe EarthingElectrode Limited'
  },
  {
    url:tata_motors,
    url2x:tata_motors2x,
     alt:'Tata Motors Logo - Ashlok Safe Earthing Electrode Limited Supplier'
  },
  {
    url:unity,
    url2x:unity2x,
     alt:'Unity InfraProjects Limited logo - Partner of Ashlok Safe Earthing Electrode Limited'
  },
  {
    url:vikram_solar,
    url2x:vikram_solar2x,
     alt:'Vikram Solar Logo - Collaboration with Vikram Solar for sustainable energy and earthing solutions'
  },
  {
    url:dmart,
    url2x:dmart2x,
     alt:'Dmart Logo -  Partner of Ashlok Safe Earthing Electrode Limited'
  },

]
const Carouselcon = ({ children, className }) => {
  return (
    <div className={`carousel ${className}`}>
      <div className="slider-track">
        {children}
       
      </div>
    </div>
  );
};


const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
    slidesToSlide: 2 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 464 },
    items: 2,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const AshlokClient = () => {
  return (
    <>
    <div className=' bg-ashred flex items-center justify-center flex-col p-2'>
    <p className='  text-white  text-2xl lg:text-3xl p-2 sm-small:p-2 sm:p-2 md-small:p-2 md:p-2 lg:p-0 '>A few who chose the <span className='vollkorn-sc-semibold'>Ashlok</span> Way…....</p>
    
</div>
<div className=' '>
                      <Infinitescrollnew images={clientImageUrl}/> 
                 
                 
                  
                  
        
</div>
</>
  )
}

export default AshlokClient